// Centralises "date-only" appointment detection used by AppointmentPicker.
// When the user ticks "No times (date only)" in AppointmentPicker, both
// appointmentCustomStart and appointmentCustomEnd are persisted at midnight
// on the chosen date. This helper lets every consumer (line UI, claim
// submission, PDF/Excel exports) treat those lines consistently.

function isMidnight(d) {
  return d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0;
}

export function isLineDateOnly(line) {
  if (!line) return false;
  const start = line.appointmentCustomStart || line.appointmentStartSet;
  const end = line.appointmentCustomEnd || line.appointmentEndSet;
  if (!start || !end) return false;
  const s = new Date(start);
  const e = new Date(end);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return false;
  return isMidnight(s) && isMidnight(e);
}

// Medical-aid switches typically require a time component. When a line is
// date-only, claim submission falls back to this default 08:00–09:00 window.
export const CLAIM_DEFAULT_START_HHMMSS = "080000";
export const CLAIM_DEFAULT_END_HHMMSS = "090000";
